import type { FaireProductEntity } from "../../entity_types/product";

export const p_3aqq9uu39j: FaireProductEntity = {
  token: "p_3aqq9uu39j",
  type: "product",
  name: "Sailboat Organic Cotton Jacquard Knit Baby Blanket",
  brandToken: "b_7fghelgl",
  brandName: "Viverano Organics",
  imageUrl:
    "https://cdn.faire.com/fastly/ace48a8996cbe83c3176828e6ea7e4c0d3e5c22b386961f3e22d8fd2608cdfa8.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/85547be402f23686b7cf8d75ecdc769534a4e7171cf8d89dd090ab0c545426a4.png",
    "https://cdn.faire.com/fastly/300de9abb19fc8d7dd3a6633c446c0f5133ebe7e13da592418305133a8376a3f.png",
    "https://cdn.faire.com/fastly/17e51cce588eb37950c2b7803b3fae4fa9f87f5d85ed1ff3310fa42685526dcd.png",
    "https://cdn.faire.com/fastly/741fde994b236c41ac33ff5410da7c601892a187da8b070de41fb48f843a2029.png",
    "https://cdn.faire.com/fastly/436d2a203e1c3257a9e797099954a8f5b1ad483aa00cbc0f5a1050f7869a8ea1.png",
  ],
  priceDollars: 26,
  description:
    "Organic Cotton Jacquard Baby Blanket – Sailboat Motif\n\nInspired by the calm rhythm of the ocean, this 100% organic cotton jacquard baby blanket features a beautifully textured knit with nautical boat motifs.\n\nThe breathable jacquard construction offers a soft, lightweight, and cozy feel, making it perfect for all seasons. Gentle on delicate skin and free from harmful chemicals, it delivers natural comfort parents can trust.\n\nMade from sustainably grown organic cotton, this blanket supports better livelihoods for small grower farmers and reflects a commitment to responsible craftsmanship. Designed in the USA and ethically made by skilled artisans in India at a GOTS-certified facility, every piece is created with care and intention.\n\nIdeal for nursery decor, stroller rides, and quiet cuddle moments—this blanket brings a touch of the sea to everyday comfort.\n\nPure comfort, by Viverano.",
  tags: [],
  msrpDollars: 52,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-08-13T19:56:51.901Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
